<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="会刊管理" :sub-title="subTitle" @back="onBack">
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                            <FGCollapsiblePanel title="会刊信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="9">
                                        <a-form-item label="会刊编号" :wrapper-col="{ span: 12 }">
                                            <a-input ref="hkbh" v-model="editData.hkbh" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="年份" :wrapper-col="{ span: 12 }">
                                            <a-input ref="nf" v-model="editData.nf" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="期数">
                                            <a-input ref="qs" v-model="editData.qs" type="number" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="总期数">
                                            <a-input ref="zqs" v-model="editData.zqs" type="number" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="会刊名称">
                                            <a-input ref="hkmc" v-model="editData.hkmc" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="出版日期" :wrapper-col="{ span: 12 }">
                                            <a-input v-model="editData.cbrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="9">
                                        <a-form-item label="接收单位范围" :wrapper-col="{ span: 12 }">
                                            <a-input ref="jsdwfw" v-model="editData.jsdwfw" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="18">
                                        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                                            <a-textarea v-model="editData.bz" :rows="3" disabled class="view" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload :attachCfg.sync="attachCfg" @updateDownload="updateXZCS" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>

<script>
export default {
    name: "HkxxcxForm",
    props: ["showForm", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            isShow: false
        };
    },
    computed: {
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        formIsVisible: {
            get() {
                return this.showForm;
            },
            set(newVal) {
                this.$emit("update:showForm", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "DW_HKJL",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "HK1001"
            };
        }
    },
    activated() {
        this.updateView();
        this.loadData();
    },
    methods: {
        // 更新查看状态
        updateView() {
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/hkgl/updateYDBJ",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxdw/hkgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.formIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.formIsVisible = false;
                    }
                });
        },
        //更新下载次数
        updateXZCS() {
            this.$FG_http
                .post("./api/main/zxdw/hkgl/updateXZCS", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                    } else {
                        this.$refs.hkbh.focus();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.formIsVisible = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.view {
    background: #fff;
    border: 0;
    color: #333;
    cursor: inherit;
}
.zpCls {
    width: 181px;
    height: 181px;
}
</style>
<style>
.cusBtnAlign .ant-modal-footer {
    text-align: center !important;
}
.view .ant-select-selection.ant-select-selection--single {
    background: #fff;
    border: 0px;
    cursor: inherit;
}
.view span.ant-select-arrow {
    display: none;
}
.view input.ant-calendar-picker-input.ant-input.ant-input-disabled {
    background: #fff;
    border: 0;
    color: #333;
    cursor: auto;
}
.view .ant-calendar-picker-icon {
    display: none;
    cursor: auto;
}
</style>
